import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import translationPTBR from './pt-BR.json';

const resources = {
  'pt-BR': {
    translation: translationPTBR
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'pt-BR',
    lng: 'pt-BR',
    debug: false,
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
